import {StorageSuccessModal} from "./StorageSuccessModal";
import * as React from "react"
import {Link} from "react-router-dom";
import {
    DirectDebitRenewalMigratedPaymentPlanOutput
} from "../../pages/dashboard/common/payments/paymentDetails/DirectDebitRenewalMigratedPaymentPlanOutput";
import * as moment from "moment";
import {formatDate} from "@ferry/plugin-ferry-journey";
import {MIGRATED_RENEWAL_STATUSES, PREMIUM_TYPE_ANNUAL} from "@ferry/journey-services";
import {getAmountWithDecimalDigits} from "../../CommonFunctions";

interface IProps {
    interaction: any;
    closeRenewalConfirmationModal: () => void;
}

interface IState {
    interaction: any;
}

export class RenewalConfirmationModal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            interaction: props.interaction
        };
    }

    public render() {
        const initialPaymentDate: string = moment.utc(this.props.interaction?.paymentDetails?.instalmentPlan.instalments[0].dueDate, moment.ISO_8601).format("D MMMM YYYY");
        const principal = this.props.interaction?.paymentDetails?.instalmentPlan.instalments[0].principal;
        const interest = this.props.interaction?.paymentDetails?.instalmentPlan.instalments[0].interest;
        const initialPayment = principal + interest;
        const cardNumber: string = this.props.interaction?.policyHolder?.cardDetails
            ? this.props.interaction?.policyHolder?.cardDetails[0].number
            : '';
        const startDateFormat: string = formatDate(this.props.interaction?.headerInfo.startDate, "DD MMM YYYY");
        const isAnnual: boolean = this.props.interaction?.factors.premiumType === PREMIUM_TYPE_ANNUAL;
        const isRenewal: boolean = MIGRATED_RENEWAL_STATUSES.includes(this.props.interaction?.status);
        const paymentDetailsPage = "/dashboard/migratedRenewal/paymentDetails";
        return (
            <>
                {isAnnual && <StorageSuccessModal
                    title="You've renewed!"
                    explanationWording={
                    <>
                        <h1 className="m-0 pb-20"><strong>Thanks {this.state.interaction?.policyHolder?.firstName},</strong></h1>
                        <p className="font-weight-bold">
                            Your car insurance policy is now scheduled to renew on {startDateFormat}.<br/>
                        </p>
                        <p><strong>{getAmountWithDecimalDigits(this.props.interaction?.factors?.amountToPay)}</strong> will be taken from your card ending in {cardNumber.slice(-4)} on {startDateFormat}. Please check your <Link className="text-decoration-underline cursor-pointer text-blue-1 muli-bold-16" to={"/dashboard"}>payment card</Link> is still valid.</p>
                    </>}
                    anythingElseTitle="Has anything else changed?"
                    explanationAnythingElseWording={
                        <p>
                            Please check everything’s still accurate and make any changes required so you can be sure all policy details are up to date.<br/>
                            You can still make changes up to your renewal date.
                        </p>
                    }
                    onClose={this.onClose}
                />}
                {!isAnnual && <StorageSuccessModal
                  title="You've renewed!"
                  explanationWording={
                      <>
                          <h1 className="m-0 pb-20"><strong>Thanks {this.props.interaction?.policyHolder?.firstName},</strong></h1>
                          <strong>Your car insurance policy is now scheduled to renew on {startDateFormat}.</strong><br/><br/>
                          <p>The first instalment of <strong>{getAmountWithDecimalDigits(initialPayment)}</strong> will be taken on {initialPaymentDate}. <strong>Please see your payment schedule below. </strong>
                              {!isRenewal && (
                                  <>
                                      Please check your <Link className="text-decoration-underline cursor-pointer text-blue-1 muli-bold-16" to={paymentDetailsPage}>payment card</Link> is still valid.
                                  </>
                              )}
                          </p>
                          <div id="paymentScheduleTable">
                              <DirectDebitRenewalMigratedPaymentPlanOutput
                                  interaction={this.state.interaction}/>
                          </div>
                      </>
                  }
                  anythingElseTitle="Has anything else changed?"
                  explanationAnythingElseWording={
                      <p>
                          Please check everything’s still accurate and make any changes required so you can be sure all policy details are up to date.<br/>
                          You can still make changes up to your renewal date.
                      </p>
                }
                  onClose={this.onClose}
                />}
            </>
        );
    }

    private readonly onClose = (): void => {
        this.props.closeRenewalConfirmationModal();
    }
}
